const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/builder`;

export const mediaUrl = (rel) => {
  if (!rel) return "";
  if (/^https?:\/\//i.test(rel)) return rel;
  return `${process.env.REACT_APP_BACKEND_URL}${rel.startsWith("/") ? rel : "/" + rel}`;
};

async function j(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || res.statusText || `HTTP ${res.status}`);
  return res.json();
}

export const API = {
  base: BASE,
  // categories
  listCategories: () => j("GET", "/categories"),
  createCategory: (d) => j("POST", "/categories", d),
  updateCategory: (id, d) => j("PUT", `/categories/${id}`, d),
  deleteCategory: (id) => j("DELETE", `/categories/${id}`),
  // products
  listProducts: (categoryId, tag) => {
    const q = new URLSearchParams();
    if (categoryId) q.set("category_id", categoryId);
    if (tag) q.set("tag", tag);
    const s = q.toString();
    return j("GET", `/products${s ? `?${s}` : ""}`);
  },
  listTags: (categoryId) => j("GET", `/tags${categoryId ? `?category_id=${categoryId}` : ""}`),
  createProduct: (d) => j("POST", "/products", d),
  updateProduct: (id, d) => j("PUT", `/products/${id}`, d),
  deleteProduct: (id) => j("DELETE", `/products/${id}`),
  publishProduct: (id) => j("POST", `/products/${id}/publish`),
  // changelog
  getChangelog: (id) => j("GET", `/products/${id}/changelog`),
  updateChangelog: (id, entries) => j("PUT", `/products/${id}/changelog`, entries),
  addChangelogEntry: (id, entry) => j("POST", `/products/${id}/changelog/entry`, entry),
  // sync
  syncPushAll: () => j("POST", "/admin/sync/push"),
  syncPushOne: (id) => j("POST", `/admin/sync/push/${id}`),
  syncPullAll: () => j("POST", "/admin/sync/pull"),
  syncPullOne: (id) => j("POST", `/admin/sync/pull/${id}`),
  syncPushStorage: (provider) => j("POST", `/admin/sync/push-storage/${provider}`),
  // media
  mediaList: (path = "", provider = "") =>
    j("GET", `/media/list?path=${encodeURIComponent(path)}${provider ? `&provider=${provider}` : ""}`),
  mediaFolder: (path, name, provider = "") => j("POST", "/media/folder", { path, name, provider }),
  mediaDelete: (path, provider = "") => j("DELETE", "/media/item", { path, provider }),
  mediaUpload: async (path, file, provider = "") => {
    const fd = new FormData();
    fd.append("path", path);
    fd.append("provider", provider);
    fd.append("file", file);
    const res = await fetch(`${BASE}/media/upload`, { method: "POST", body: fd });
    if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "Upload failed");
    return res.json();
  },
  // ai rules
  getAiRules: () => j("GET", "/ai-rules"),
  saveAiRules: (rules) => j("PUT", "/ai-rules", { rules }),
  // storage providers
  storageProviders: () => j("GET", "/storage/providers"),
  saveStorage: (provider, d) => j("PUT", `/storage/settings/${provider}`, d),
  testStorage: (provider) => j("POST", `/storage/settings/${provider}/test`),
};

export default API;
